import React from "react";
import "./SearchBox.css";

const SearchBox = ({ searchChange, responseMessage, placeholder }) => {
  return (
    <div className="DatatableFilter">
      <label className="FilterLabel"></label>
      <input
        className="SearchBox"
        type="search"
        onChange={searchChange}
        placeholder={placeholder}
      />
      <div className="red">{responseMessage}</div>
    </div>
  );
};

export default SearchBox;
